var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 52,
    viewBox: "0 0 62 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_1045)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_59_1045",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20H44C45.1046 20 46 19.1046 46 18C46 16.8954 45.1046 16 44 16H18ZM18 24C16.8954 24 16 24.8954 16 26C16 27.1046 16.8954 28 18 28H44C45.1046 28 46 27.1046 46 26C46 24.8954 45.1046 24 44 24H18ZM16 34C16 32.8954 16.8954 32 18 32H44C45.1046 32 46 32.8954 46 34C46 35.1046 45.1046 36 44 36H18C16.8954 36 16 35.1046 16 34Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20H44C45.1046 20 46 19.1046 46 18C46 16.8954 45.1046 16 44 16H18ZM18 24C16.8954 24 16 24.8954 16 26C16 27.1046 16.8954 28 18 28H44C45.1046 28 46 27.1046 46 26C46 24.8954 45.1046 24 44 24H18ZM16 34C16 32.8954 16.8954 32 18 32H44C45.1046 32 46 32.8954 46 34C46 35.1046 45.1046 36 44 36H18C16.8954 36 16 35.1046 16 34Z",
    fill: "#EB00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18C17 17.4477 17.4477 17 18 17V15C16.3431 15 15 16.3431 15 18H17ZM18 19C17.4477 19 17 18.5523 17 18H15C15 19.6569 16.3431 21 18 21V19ZM44 19H18V21H44V19ZM45 18C45 18.5523 44.5523 19 44 19V21C45.6569 21 47 19.6569 47 18H45ZM44 17C44.5523 17 45 17.4477 45 18H47C47 16.3431 45.6569 15 44 15V17ZM18 17H44V15H18V17ZM17 26C17 25.4477 17.4477 25 18 25V23C16.3431 23 15 24.3431 15 26H17ZM18 27C17.4477 27 17 26.5523 17 26H15C15 27.6569 16.3431 29 18 29V27ZM44 27H18V29H44V27ZM45 26C45 26.5523 44.5523 27 44 27V29C45.6569 29 47 27.6569 47 26H45ZM44 25C44.5523 25 45 25.4477 45 26H47C47 24.3431 45.6569 23 44 23V25ZM18 25H44V23H18V25ZM18 31C16.3431 31 15 32.3431 15 34H17C17 33.4477 17.4477 33 18 33V31ZM44 31H18V33H44V31ZM47 34C47 32.3431 45.6569 31 44 31V33C44.5523 33 45 33.4477 45 34H47ZM44 37C45.6569 37 47 35.6569 47 34H45C45 34.5523 44.5523 35 44 35V37ZM18 37H44V35H18V37ZM15 34C15 35.6569 16.3431 37 18 37V35C17.4477 35 17 34.5523 17 34H15Z",
    fill: "white",
    mask: "url(#path-1-inside-1_59_1045)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_1045",
    x: 0,
    y: 0,
    width: 62,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_1045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_1045",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.7b209778626cf94436910bd342631b5c.svg";
export { ForwardRef as ReactComponent };